import { useQuery } from '@tanstack/react-query';
import { useTransactionService } from '../../../services/transaction.service';
import { TransactionsFilterData } from '../../../services/transaction.types';

export const useTransactionQueries = (
    page: number,
    rowsPerPage: number,
    order: 'asc' | 'desc',
    orderBy: string,
    filters: TransactionsFilterData
) => {
    const transactionService = useTransactionService();

    const {
        data: transactionResponse,
        isLoading,
        isFetching,
    } = useQuery({
        queryKey: ['transactions', page, rowsPerPage, order, orderBy, filters],
        queryFn: () => transactionService.get(page, rowsPerPage, filters, order, orderBy),
        gcTime: 0,
    });

    const { data: transactionTypes = [] } = useQuery({
        queryKey: ['transactionTypes'],
        queryFn: () => transactionService.getTypes(),
    });

    return {
        transactionResponse,
        transactionTypes,
        isLoading,
        isFetching,
    };
};
